// key = language, value = url
export const HelpLink: {[key: string]: string} = {
    de: './res/custom_help/de_icons.html',
    en: './res/custom_help/en_icons.html',
    es: './res/custom_help/es_icons.html',
    fr: './res/custom_help/fr_icons.html',
};
export const HelpIframeLink: {[key: string]: string} = {
    de: './res/help_mobile/de_faq.html',
    en: './res/help_mobile/en_faq.html',
    es: './res/help_mobile/es_faq.html',
    fr: './res/help_mobile/fr_faq.html',
    it: './res/help_mobile/it_faq.html',
    nl: './res/help_mobile/nl_faq.html',
    pl: './res/help_mobile/pl_faq.html',
    pt: './res/help_mobile/pt_faq.html',
    ro: './res/help_mobile/ro_faq.html',
    tr: './res/help_mobile/tr_faq.html',
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/LinkConstants.ts